import * as Sentry from '@sentry/react';
import type { PropsWithChildren } from 'react';

function ErrorFallback({ error }: { error: Error }) {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Something went wrong</h2>
      <p>{error.message}</p>
      <button onClick={() => window.location.reload()}>Reload</button>
    </div>
  );
}

export function SentryErrorBoundary({ children }: PropsWithChildren) {
  return (
    <Sentry.ErrorBoundary fallback={({ error }) => <ErrorFallback error={error as Error} />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
